import { loadScript } from "./utils";

let apiPromise = null;

export function loadYouTubeApi() {
	if (apiPromise) return apiPromise;

	apiPromise = new Promise((resolve, reject) => {
		// Already loaded (HMR, another script, etc.)
		if (window.YT && window.YT.Player) {
			resolve(window.YT);
			return;
		}

		// Chain any existing callback instead of overwriting it
		const previous = window.onYouTubeIframeAPIReady;
		window.onYouTubeIframeAPIReady = () => {
			if (typeof previous === "function") previous();
			resolve(window.YT);
		};

		loadScript("yt-api", "https://www.youtube.com/iframe_api").catch((err) => {
			apiPromise = null; // allow retry
			reject(err);
		});
	});

	return apiPromise;
}

const players = new Map();

export async function createYTPlayer(elementOrId, options = {}) {
	const YT = await loadYouTubeApi();

	// Key by the element's id, or by whatever key you pass in
	const key =
		options.key ??
		(typeof elementOrId === "string" ? elementOrId : elementOrId.id);

	return new Promise((resolve) => {
		const player = new YT.Player(elementOrId, {
			...options,
			events: {
				...options.events,
				onReady: (e) => {
					players.set(key, player);
					options.events?.onReady?.(e);
					resolve(player);
				},
			},
		});
	});
}

export function getYTPlayer(key) {
	return players.get(key);
}

export function destroyYTPlayer(key) {
	players.get(key)?.destroy();
	players.delete(key);
}
